export const IDENTITY_PROVIDER = {
  NV_USERNAME_PASSWORD: 'nv-username-password',
  NV_CLIENT_CREDENTIALS: 'nv-client-credentials',
  NV_OTP: 'nv-otp',
  GOOGLE_OAUTH2: 'google-oauth2'
} as const
